<template>
  <div class="appMakeCenter">
      <search-bar class="mt-8 mb-5 print-hide"></search-bar>
    <v-main :class="mainContainer" id="home">
      <v-tabs
        v-model="mainContainerActiveTab"
        id="globalTab"
        class="mt-6 mb-4 print-hide pl-0"
        hide-slider
        fixed-tabs
        :show-arrows="false"
      >
        <!--<v-tabs-slider color="#e2e3e1"></v-tabs-slider>-->
        <v-tab
          v-for="tab of tabs"
          :key="tab.id"
          @click="tabClickHandler('page-' + tab.id)"
          :id="`glbTab-${tab.id}`"
          class="pt-2 pb-2 mr-4"
        >
          {{ tab.name }}
        </v-tab>
      </v-tabs>
      <div
          class="text-left mt-md-n4 mt-sm-7 mb-xs-4 font-weight-regular caption" >
          This site provides information about code usage in the United States or Internationally. Select a tab and search by state, code or country.
      </div>
      <router-view />
    </v-main>
  </div>
</template>
<script>
import SearchBar from './../search/Search.vue'

export default {
  name: 'MainLayoutContainer',
  components: {
    'search-bar': SearchBar
  },
  data: () => ({
    mainContainerActiveTab: null,
    tabs: [
      { id: 1, name: 'U.S. Code Adoptions' },
      { id: 2, name: 'U.S. I-Codes Maps' },
      { id: 3, name: 'Global Codes' }
    ]
  }),
  computed: {
    mainContainer () {
      return (this.$vuetify.breakpoint.width <= 600) ? 'bg-white ml-4 mr-4' : 'pl-0 pr-0'
    }
  },
  methods: {
    tabClickHandler (pageId) {
      switch (pageId) {
        case 'page-1':
          this.$router.push({ name: 'Home', params: { pageId: true, locateMe: true } }).catch(err => err)
          break
        case 'page-2':
          this.$router.push({ name: 'ICodeMap', params: { icode: 'IBC', pageId: true } }).catch(err => err)
          break
        case 'page-3':
          this.$router.push({ name: 'GlobalCodes', params: { pageId: true, locateMe: true } }).catch(err => err)
          break
      }
      this.$globalFromValidation.forceTabActive(this.$route.name)
    }
  },
  mounted () {
    this.$globalFromValidation.forceTabActive(this.$route.name)
  }
}
</script>
